import React from "react";

const LoadingDots = () => {
	return (
		<span className="dots">
			<span>.</span>
			<span>.</span>
			<span>.</span>
		</span>
	);
};

export default LoadingDots;
